import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { MaterialModule } from '../shared/material.module';
import { SecurityRoutingModule } from './security-routing.module';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { IdentityService } from './identity.service';
import { EmailLoginComponent } from './login-layout/email-login/email-login.component';
import { PhoneLoginComponent } from './login-layout/phone-login/phone-login.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireAuthGuardModule } from '@angular/fire/auth-guard';
import { SignUpComponent } from './sign-up/sign-up.component';
import { PhoneSignupComponent } from './sign-up/phone-signup/phone-signup.component';
import { EmailSignupComponent } from './sign-up/email-signup/email-signup.component';

@NgModule({
  declarations: [
    LoginLayoutComponent,
    EmailLoginComponent,
    PhoneLoginComponent,
    EmailSignupComponent,
    PhoneSignupComponent,
    SignUpComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    SecurityRoutingModule,
    AngularFireAuthModule,
    AngularFireAuthGuardModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [IdentityService]
})
export class SecurityModule {}
